import UploadDirectoryDocument from "./document";

export default UploadDirectoryDocument;
